
import axios from 'axios';
import UserToken from './GetUserToken';
// import { useNavigate } from "react-router-dom";
// import {Interceptor200, Interceptor404 , Interceptor400} from './Interceptors';


// import { useTranslation } from 'react-i18next';


const BASE_URL = process.env.REACT_APP_BASE_URL;
 //https://www.dhiwise.com/post/the-new-age-axios-aetup-separation-of-concerns-in-react

const getCurrentLanguage = () => {
  return localStorage.getItem('i18nextLng') || 'fa';
};


const Interceptor404 = (data=null)=>{

 
    return Promise.resolve({
        status: 404,
        hasError : true,
        message: 'No data avilable.',
        data: data, 
        isNotFound: true 
      });


};

const Interceptor200 = (data)=>{
 

  return Promise.resolve({
      status: 200,
      hasError : false,
      message: 'Ok',
      data: data, 
      isNotFound: false 
    });


};


const Interceptor400 = (response)=>{
 
  const errors = response.errors || [{errorMessage:response.message || 'unknown error!'}];
  let errorList = [];

  errors.map((error, index)=>{
    errorList.push(error.errorMessage);
  });
  
  const titleError =  (response.title || 'Error')+': '+errorList.join(' - ');
  return Promise.resolve({
      status: 400,
      hasError : true,
      message: titleError,
      data: null, 
      isNotFound: false 
    });


};




const apiHandler = axios.create({
  baseURL: BASE_URL ,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Author':'MatinRayanehAryan.ir'
  },
});

 
apiHandler.interceptors.response.use(
  // response => response,
  (response) => {
    // Modify response data before passing it to the calling function
    return response.data;
    //Interceptor200
  },
  error => {
    console.error('API call failed:', error);
    // Handle specific error cases
    if (error.response.status === 401) {
     
      // const navigate = useNavigate();
      // navigate(`/byebye?error=${401}`, { replace: true });  
      if (navigateRef) {
        navigateRef(`/byebye?error=${401}`, { replace: true });
      }

      // Unauthorized
    } else if (error.response.status === 404) {
      // Not found
      return Interceptor404(error.response.data); // 404 as OK response
    }
    else if (error.response.status === 400) {
      // Validation Error
      return Interceptor400(error.response.data ?? error.response.message); // 400 as OK response
    }
    return Promise.reject(error);
  }
);

 // Request interceptor
 apiHandler.interceptors.request.use(
    (config) => {
      // console.log(config)
      // console.log(UserToken())
      // Modify config before sending the request
      //if(UserToken)
      
      let lang = 'fa';

      try {
          lang = getCurrentLanguage()
          // console.log('FRONT HTTP lang : ',lang);

      } 
      catch (ex){
          console.log(ex);
          lang = 'fa';    
      } 
    
      config.headers['Authorization'] = `Bearer ${UserToken()}`;
      config.headers['Accept-Language'] = lang;
      
      // console.log('axios config... ',config)
      return config;
    },
    (error) => {
      // Handle request error
      return Promise.reject(error);
    }
  );

const Get = async (endPoint)=>{

    try {
        const response = await apiHandler.get(endPoint);
        return response; 
      } catch (error) {
        
        console.error(`Error requst to  ${endPoint}:`, error);
        throw error;
      }

};



// Store the navigation function reference
let navigateRef = null;

// Method to set navigation from a component
export const setNavigate = (navigate) => {
  navigateRef = navigate;
};

const Post = async (endPoint,dataObject)=>{

    try {
        const response = await apiHandler.post(endPoint,dataObject);
        return response; 
      } catch (error) {
        
        console.error(`Error requst to  ${endPoint}:`, error);
        throw error;
      }

};

const Put = async (endPoint,dataObject)=>{

  try {
      const response = await apiHandler.put(endPoint,dataObject);
      return response; 
    } catch (error) {
      
      console.error(`Error requst to  ${endPoint}:`, error);
      throw error;
    }

};


const Delete = async (endPoint)=>{

  try {
      const response = await apiHandler.delete(endPoint);
      return response; 
    } catch (error) {
      
      console.error(`Error requst to  ${endPoint}:`, error);
      throw error;
    }

};

const PostFile = async (endPoint,form_data)=>{

    try {




        const response = await apiHandler.post(endPoint, form_data, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });       
          return response; 
      } catch (error) {
        
        console.error(`Error requst to  ${endPoint}:`, error);
        throw error;
      }

};


const PutFile = async (endPoint,form_data)=>{

  try {





      const response = await apiHandler.put(endPoint, form_data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });       
        return response; 
    } catch (error) {
      
      console.error(`Error requst to  ${endPoint}:`, error);
      throw error;
    }

};



export default {
  Get, Post, PostFile, Put, PutFile, Delete, setNavigate
};